import * as React from "react";
import { forwardRef } from "react";
const SvgDropdownIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 12, viewBox: "0 0 23 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M22 1.70547L11.8516 10.6562L1.70312 1.70547", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgDropdownIcon);
export { ForwardRef as ReactComponent };
